<script>
export default {
  props: {
    seconds: {
      type: Number,
      default: 30
    },
    redirectUrl: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      remaining: this.seconds
    };
  },
  mounted() {
    this.tick();
  },
  beforeDestroy() {
    clearTimeout(this._timer);
  },
  methods: {
    tick() {
      if (this.remaining <= 0) {
        this.$emit("done");
        if (this.redirectUrl) {
          window.location.href = this.redirectUrl;
        }
        return;
      }
      this._timer = setTimeout(() => {
        this.remaining--;
        this.tick();
      }, 1000);
    }
  },
  render(h) {
    if (this.$scopedSlots.default) {
      const children = this.$scopedSlots.default({ remaining: this.remaining });
      return h(
        "span",
        { class: "v-countdown" },
        Array.isArray(children) ? children : [children]
      );
    }
    return h("span", { class: "v-countdown" }, [String(this.remaining)]);
  }
};
</script>

<style lang="scss">
.v-countdown {
  font-variant-numeric: tabular-nums;
}
</style>
